import API from './api';

export const updateLessonCompleted = ({ courseId, lessonId, isCompleted }) =>
  API.put(`/course/${courseId}/lesson/${lessonId}`, {
    isConcluded: isCompleted,
  })
    .then(res => res)
    .catch(err => {
      throw err;
    });

export const fetchFiles = ({ courseId, lessonId }) =>
  API.get(`/course/${courseId}/lesson/${lessonId}`)
    .then(res => res.data?.files)
    .catch(err => {
      throw err;
    });

export const fetchQuestions = ({ courseId, lessonId }) =>
  API.get(`/course/${courseId}/lesson/${lessonId}/questions`)
    .then(res => res)
    .catch(err => {
      throw err;
    });
